import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-footer-user',
  templateUrl: './footer-user.component.html',
  styleUrls: ['./footer-user.component.css'],
})
export class FooterUserComponent implements OnInit {
  checkShowFooter = false;
  currentUrl: string = ''; // Initialize currentUrl
  currentDate = new Date()
  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    const access = localStorage.getItem('access');
    this.router.events.subscribe((event) => {
      if (access && access.includes('admin')) {
        this.checkShowFooter = false;
      } else if (!access) {
        this.checkShowFooter = false;
      } else {
        this.checkShowFooter = true;
      }
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
      }
    });
  }
}
